module.exports = __webpack_public_path__ + "img/fiat-smartrace-autoshow-03.5bd13a26.jpg";